/*
 * @Author: 王峥 wangzheng_jzb@tal.com
 * @Date: 2024-10-15 17:58:35
 * @LastEditors: XuJingXin v_xujingxin@tal.com
 * @LastEditTime: 2024-11-12 11:45:26
 * @FilePath: /fe-react-template/src/containers/app/HashRouter.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { History } from 'history';
import { HashRouterProps as NativeHashRouterProps, Router } from 'react-router-dom';

export interface HashRouterProps extends Omit<NativeHashRouterProps, 'window'> {
    history: History;
}

const HashRouter: React.FC<HashRouterProps> = React.memo((props) => {
    const { history, ...restProps } = props;
    console.log('history', props,restProps);
    
    const [state, setState] = React.useState({
        action: history.action,
        location: history.location,
    });

    React.useLayoutEffect(() => history.listen(setState), [history]);

    return (
        <Router
            {...restProps}
            location={state.location}
            navigationType={state.action}
            navigator={history}
        />
    );
});

export default HashRouter;
